/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'mustache',
    'window',
    'pip-events',
    'pip-common.utils',
    '@thd-olt-global/thd-customer'

  ],
  function (
    $,
    pip,
    Mustache,
    window,
    pipEvents,
    pipCommonUtils,
    thdCustomer
  ){

    var BADGING_SERVICE_URL = '/thdrecommends/v1/badges';
    var DYNAMIC_BADGING_SERVICE_URL = '/dynamicrecs/badges';
    var BADGING_SERVICE_KEY = '2nrNAYZcoqFW7rkBAUqVudGbGcxmL6s1';
    var ALGORITHM_MODEL_PARAM = 'model1';
    var THD_CUSTOMER_ROLE_ADMIN = 'ADMIN';
    var view = {
      templates: {
        badging : $('#badging__layout').html()
      },
      selectors: {
        badging: '#badging__container'
      },
      updateDOM: {
        renderBadge : function renderBadge() {
          $(view.selectors.badging).html(viewModel.render.badgingLayout(viewModel.filteredBadges));
        }
      }
    };

    var model = {
      fetch: {
        badgingData: function badgingData(){
          var itemId;
          var itemIds;
          var storeId;
          var platform;
          var algorithmModel;
          var key;
          if (pip.products.primary.data && pip.products.primary.data.itemId && pip.customer.localStore && pip.customer.localStore.storenumber && pip.platform) {
            itemId = pip.products.primary.data.itemId;
            itemIds = '&itemids=' + itemId;
            storeId = '&storeid=' + pip.customer.localStore.storenumber;
            platform = pip.platform.toLowerCase() === 'mobile' ? 'mobileweb' : 'desktop';
            platform = '?appid=' + platform;
            algorithmModel = '&algorithmmodel=' + ALGORITHM_MODEL_PARAM;
            key = '&key=' + BADGING_SERVICE_KEY;
          } else return;
          var ajaxUrl = BADGING_SERVICE_URL;
          var urlParams = platform + algorithmModel + itemIds + key + storeId;
          $.ajax({
            url: ajaxUrl + urlParams,
            dataType: 'jsonp',
            contentType: 'application/json',
            timeout: 9000,
            success: function (data) {
              viewModel.displayBadge(data, itemId);
            }
          });
        },
        getBadgeDetails: function getBadgeDetails(){
          var itemId;
          var storeId;
          var key;
          if (pip.products.primary.data && pip.products.primary.data.itemId && pip.customer.localStore && pip.customer.localStore.storenumber && pip.platform) {
            itemId = '?anchor=' + pip.products.primary.data.itemId;
            storeId = '&storeid=' + pip.customer.localStore.storenumber;
            key = '&key=' + BADGING_SERVICE_KEY;
          } else return;
          var ajaxUrl = DYNAMIC_BADGING_SERVICE_URL;
          var urlParams = itemId + key + storeId;
          $.ajax({
            url: ajaxUrl + urlParams,
            contentType: 'application/json',
            timeout: 9000,
            success: function (data) {
              viewModel.displayBadge(data, itemId);
            }
          });
        }
      }
    };

    var viewModel = {
      render: {
        badgingLayout: function (badge) {
          return Mustache.render(view.templates.badging, { badge: badge });
        }
      },
      hasBadges: function hasBadges(data, itemId) {
        if (pip.features.dynamicRecsBadgeApiEnabled) {
          return !!(data
            && data.products
            && data.products[0].itemLabels
            && data.products[0].itemLabels.badges
            && data.products[0].itemLabels.badges.length)
        }
        else return !!(data
          && data.badgePriceStickerDetails
          && data.badgePriceStickerDetails[itemId]
          && data.badgePriceStickerDetails[itemId].badges
          && data.badgePriceStickerDetails[itemId].badges.length)
      },
      showFilteredBadge: function showFilteredBadge (data, itemId){
        viewModel.filteredBadges = [];
        if (pip.features.dynamicRecsBadgeApiEnabled) {
          var firstbadgeModel = pipCommonUtils.deepGet(data.products[0], 'itemLabels.badges');
          viewModel.filteredBadges.push(
          {
            "name": firstbadgeModel[0].name,
            "message": firstbadgeModel[0].message,
            "label": firstbadgeModel[0].label
          });
        }
        else {
          viewModel.filteredBadges.push(data.badgePriceStickerDetails[itemId].badges[0]);
        }
        return viewModel.filteredBadges;
      },
      displayBadge: function displayBadge(data, itemId){
        if (!viewModel.hasBadges(data, itemId)) return;
        viewModel.showFilteredBadge(data, itemId);
        view.updateDOM.renderBadge();
        pip.viewModel.badging = viewModel;
        pipEvents.badging.badgingInitialized.trigger();
      }
    };

    function isBadgingEnabled() {
      return (pip.features.pipBadgingFeature && pip.features.pipBadgingFeature.isEnabled);
    }



    function initEventListeners() {

      if(pip.features.customProductOfferingEnabled && pip.isB2BCustomer) {
        pipEvents.customProductOffering.cpoInfoReceived.on(
          function (event, cpoResponse) {
            if (!cpoResponse.isPending || thdCustomer.default.role === THD_CUSTOMER_ROLE_ADMIN) {
              if (cpoResponse.inCpo) {
                viewModel.filteredBadges =
                  [{
                    "name": "Custom Catalog",
                    "message": "Item is in your Custom Catalog",
                    "label": "Custom Catalog"
                  }];
                view.updateDOM.renderBadge();
              }
           }
          });
      }
    }

      function hasBadgeRecommendationFeatures() {
      return (pip.products
        && pip.products.primary
        && pip.products.primary.data
        && pip.products.primary.data.info
        && pip.products.primary.data.info.recommendationFeatures
        && pip.products.primary.data.info.recommendationFeatures.indexOf('BAD') > -1);
    }

    return {
      init: function init() {
        if (isBadgingEnabled() && hasBadgeRecommendationFeatures()) {
          if (pip.features.dynamicRecsBadgeApiEnabled) {
            model.fetch.getBadgeDetails();
          } else {
            model.fetch.badgingData();
          }
        }
        initEventListeners();

      },
      isBadgingEnabled: isBadgingEnabled,
      view: view,
      model: model,
      viewModel: viewModel
    }
  });

}.call(window));